<template>
  <div class="flex flex-col min-h-screen">
    <div class="flex justify-end m-5">
      <LanguageSwitcher />
    </div>
    <Calculator/>
    <Footer/>
  </div>
</template>

<script>
import Calculator from './components/DateCalculator.vue'
import Footer from "@/components/Footer";
import LanguageSwitcher from "./components/LanguageSwitcher.vue";

export default {
  name: 'App',
  components: {
    LanguageSwitcher,
    Calculator,
    Footer
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
</style>
